import bulkExpressionParser from '../simpleScript/expressionParser/bulkExpressionParser';
import { PDFDocument } from 'pdf-lib';

export default async function(
    functionObj={},
    variableObject={},
    parameterObject={},
    functionMap={},
    variableIdMap={}
){
    try{
        const {
            executionObject={}
        } = functionObj;
        const {
            variableName='', 
            variableUnavailable=false, 
        } = executionObject;

        if(!variableName || variableUnavailable){
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Variable name is missing.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let parsedParameters = await bulkExpressionParser({
            executionObject,
            variableObject,
            parameterObject,
            functionMap,
            variableIdMap,
            useAllFields : true
        });

        if(parsedParameters.error){
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Failed to resolve function parameters.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let resolvedParams = parsedParameters['accumulator'];
        if(!resolvedParams['pdf']){
            console.log('splitPdfPagesParser ERROR - PDF data is required');
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'PDF data is required',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let variableCopy = parsedParameters['variableObject'];
        const srcDoc = await PDFDocument.load(resolvedParams['pdf']);
        const pageCount = srcDoc.getPageCount();
        const pages = [];

        for (let i = 0; i < pageCount; i++) {
            const newDoc = await PDFDocument.create();
            const [copiedPage] = await newDoc.copyPages(srcDoc, [i]);
            newDoc.addPage(copiedPage);
            const base64 = await newDoc.saveAsBase64({ dataUri: true }); // data:application/pdf;base64,...
            pages.push({
                pageNumber : i + 1,
                base64
            });
        }
        
        variableCopy[variableName] = pages;

        return {
            hasError : false,
            errorPayload : undefined,
            hasReturnStatement : false,
            returnStatement : undefined,
            updatedVariableObject : variableCopy
        }
    }catch(e){
        console.log('/utils/functionParser/general/functionTypeParser/splitPdfPagesParser catch block error', e);
        return {
            updatedVariableObject : variableObject,
            hasError : true,
            errorPayload : e.stack,
            hasReturnStatement : false,
            returnStatement : []
        } 
    }
}